<div class="dx-fieldset">
  <div class="dx-field">
    <div class="dx-field-label">Thèmes</div>
    <div class="dx-field-value">
      <dx-select-box [items]="themeList" [(value)]="selectedThemeId" valueExpr="id" displayExpr="text" (onValueChanged)="onThemeChange($event)" ></dx-select-box>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label">Personnalisation grille</div>
    <div class="dx-field-value">
      <dx-button text="Supprimer les préférences de grilles" (onClick)="onSupprimerStateStorage()"></dx-button>
    </div>
  </div>  
  <div>
    <h5 style="margin-bottom: 2rem">Mode Préversion</h5>
    <div style="margin-bottom: 1rem;">
      <dx-check-box text="Activer le mode préversion" (onValueChanged)="updatePreviewMode($event)" [value]="isPreviewModeEnabled"/>
    </div>
    <div *ngIf="isPreviewModeEnabled" style="margin-left: 20px; color: #888; font-style: italic;">
      Le mode préversion active toutes les fonctionnalités expérimentales de l'application.
    </div>
  </div>
</div>
